(function () {
  //Remove the view transition render blocker if the user has reduced motion enabled
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const viewTransitionRenderBlocker = document.getElementById('view-transition-render-blocker');
    if (viewTransitionRenderBlocker) viewTransitionRenderBlocker.remove();
  }

  // Polyfill for requestIdleCallback with proper deadline object
  const idleCallback = typeof requestIdleCallback === 'function'
    ? requestIdleCallback
    : (callback) => setTimeout(() => callback({
        didTimeout: false,
        timeRemaining: () => 50
      }), 1);

  /**
   * @param {PageSwapEvent} event
   */
  window.addEventListener('pageswap', async (event) => {
    if (!hasViewTransition(event)) return;

    const { viewTransition } = event;

    // Clean in case you landed on the pdp first. We want to remove the default transition type on the PDP media gallery so there is no duplicate transition name
    document
      .querySelectorAll('[data-view-transition-type]:not([data-view-transition-triggered])')
      .forEach((element) => {
        element.removeAttribute('data-view-transition-type');
      });

    const transitionTriggered = document.querySelector('[data-view-transition-triggered]');
    const transitionType = transitionTriggered?.getAttribute('data-view-transition-type');

    // Check if types API is supported
    if (viewTransition.types && typeof viewTransition.types.add === 'function') {
      if (transitionType) {
        try {
          viewTransition.types.clear();
          viewTransition.types.add(transitionType);
        } catch (e) {
          // Types API might fail
        }
        try {
          sessionStorage.setItem('custom-transition-type', transitionType);
        } catch (e) {
          // Storage might be disabled or in private browsing mode
        }
      } else {
        try {
          viewTransition.types.clear();
          viewTransition.types.add('page-navigation');
        } catch (e) {
          // Types API might fail
        }
        try {
          sessionStorage.removeItem('custom-transition-type');
        } catch (e) {
          // Storage might be disabled or in private browsing mode
        }
      }
    }
  });

  /**
   * @param {PageRevealEvent} event
   */
  window.addEventListener('pagereveal', async (event) => {
    if (!hasViewTransition(event)) return;

    const { viewTransition } = event;
    let customTransitionType = null;
    try {
      customTransitionType = sessionStorage.getItem('custom-transition-type');
    } catch (e) {
      // Storage might be disabled or in private browsing mode
    }

    if (customTransitionType && viewTransition.types && typeof viewTransition.types.add === 'function') {
      try {
        viewTransition.types.clear();
        viewTransition.types.add(customTransitionType);
      } catch (e) {
        // Types API might fail
      }

      await viewTransition.finished;

      try {
        viewTransition.types.clear();
        viewTransition.types.add('page-navigation');
      } catch (e) {
        // Types API might fail
      }

      idleCallback(() => {
        try {
          sessionStorage.removeItem('custom-transition-type');
        } catch (e) {
          // Storage might be disabled or in private browsing mode
        }
        document.querySelectorAll('[data-view-transition-type]').forEach((element) => {
          element.removeAttribute('data-view-transition-type');
        });
      });
    } else if (viewTransition.types && typeof viewTransition.types.add === 'function') {
      try {
        viewTransition.types.clear();
        viewTransition.types.add('page-navigation');
      } catch (e) {
        // Types API might fail
      }
    }
  });

  /**
   * Checks whether an Event object is carrying a `viewTransition` property
   * (as used by the View Transition API) and narrows the type accordingly.
   *
   * @template {Event} T
   * @param {T} event
   * @returns {event is T & { viewTransition: ViewTransition }}
   */
  function hasViewTransition(event) {
    return 'viewTransition' in event && event.viewTransition instanceof ViewTransition;
  }
})();
